enum EFilters {
  getFilters = "tags/get",
  getAvailableFilters = "availableTags/get",
}

export default EFilters;
